import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
  routes: [{
    path: '/web',
    component: resolve => require(['@/views/web/index.vue'], resolve),
    redirect: '/web/index',
  }, {
    path: '/Login',
    component: resolve => require(['@/views/Login.vue'], resolve),
  }, {
    path: '/',
    component: resolve => require(['@/views/web/index.vue'], resolve),
    redirect: '/web/index',
  },
  {
    path: '/screen',
    component: resolve => require(['@/views/screen.vue'], resolve),
  },
  {
    path: '/course/bjy-live',
    component: resolve => require(['@/views/bjy-live-room/index.vue'], resolve),
  },
  {
    path: '/web/index',
    component: resolve => require(['@/views/web/index.vue'], resolve),
  },
  {
    path: '/web/shop',
    component: resolve => require(['@/views/web/shop.vue'], resolve),
  },
  {
    path: '/web/shop_detail',
    component: resolve => require(['@/views/web/shop_detail.vue'], resolve),
  },
  {
    path: '/web/chapter',
    component: resolve => require(['@/views/web/chapter.vue'], resolve),
  },
  {
    path: '/web/mock_chapter',
    component: resolve => require(['@/views/web/mock_chapter.vue'], resolve),
  },
  {
    path: '/web/mock_paper',
    component: resolve => require(['@/views/web/mock_paper.vue'], resolve),
  },
  {
    path: '/web/follow',
    component: resolve => require(['@/views/web/follow.vue'], resolve),
  },
  {
    path: '/web/square',
    component: resolve => require(['@/views/web/square.vue'], resolve),
  },
  {
    path: '/web/square_detail',
    component: resolve => require(['@/views/web/square_detail.vue'], resolve),
  },
  {
    path: '/web/knowledge',
    component: resolve => require(['@/views/web/knowledge.vue'], resolve),
  },
  {
    path: '/web/knowledge_detail',
    component: resolve => require(['@/views/web/knowledge_detail.vue'], resolve),
  },
  {
    path: '/web/knowledge_report',
    component: resolve => require(['@/views/web/knowledge_report.vue'], resolve),
  },
  {
    path: '/payment/index',
    component: resolve => require(['@/views/payment/index.vue'], resolve),
  },
  {
    path: '/payment/confirm',
    component: resolve => require(['@/views/payment/confirm.vue'], resolve),
  },

  {
    path: '/meco/index',
    component: resolve => require(['@/views/meco/index.vue'], resolve)
  },
  {
    path: '/meco/login',
    component: resolve => require(['@/views/meco/login.vue'], resolve)
  },
  {
    path: '/meco/notice',
    component: resolve => require(['@/views/meco/notice.vue'], resolve)
  },
  {
    path: '/meco/question',
    component: resolve => require(['@/views/meco/question.vue'], resolve)
  },
  {
    path: '/meco/result',
    component: resolve => require(['@/views/meco/result.vue'], resolve)
  },
  {
    path: '/meco/yiwei/index',
    component: resolve => require(['@/views/meco/yiwei/index.vue'], resolve)
  },
  {
    path: '/meco/yiwei/login',
    component: resolve => require(['@/views/meco/yiwei/login.vue'], resolve)
  },
  {
    path: '/meco/yiwei/user',
    component: resolve => require(['@/views/meco/yiwei/user.vue'], resolve)
  },
  {
    path: '/meco/yiwei/papers',
    component: resolve => require(['@/views/meco/yiwei/papers.vue'], resolve)
  },
  {
    path: '/doctor/index',
    component: resolve => require(['@/views/meco/doctor/index.vue'], resolve)
  },
  {
    path: '/doctor/login',
    component: resolve => require(['@/views/meco/doctor/login.vue'], resolve)
  },
  {
    path: '/doctor/notice',
    component: resolve => require(['@/views/meco/doctor/notice.vue'], resolve)
  },
  {
    path: '/doctor/question',
    component: resolve => require(['@/views/meco/doctor/question.vue'], resolve)
  },
  {
    path: '/doctor/result',
    component: resolve => require(['@/views/meco/doctor/result.vue'], resolve)
  },
  {
    path: '/guide/index',
    component: resolve => require(['@/views/guide/index.vue'], resolve)
  },
  {
    path: '/guide/notice',
    component: resolve => require(['@/views/guide/notice.vue'], resolve)
  },
  {
    path: '/guide/question',
    component: resolve => require(['@/views/guide/question.vue'], resolve)
  },
  {
    path: '/guide/login',
    component: resolve => require(['@/views/guide/login.vue'], resolve)
  },
  {
    path: '/guide/ces/index',
    component: resolve => require(['@/views/guide/ces/index.vue'], resolve)
  },
  {
    path: '/guide/ces/login',
    component: resolve => require(['@/views/guide/ces/login.vue'], resolve)
  },
  {
    path: '/guide/ces/notice',
    component: resolve => require(['@/views/guide/ces/notice.vue'], resolve)
  },
  {
    path: '/guide/ces/question',
    component: resolve => require(['@/views/guide/ces/question.vue'], resolve)
  },
  {
    path: '/guide/ces/result',
    component: resolve => require(['@/views/guide/ces/result.vue'], resolve)
  },
  {
    path: '/guide/account/login',
    component: resolve => require(['@/views/guide/account/login.vue'], resolve)
  },
  {
    path: '/guide/account/index',
    component: resolve => require(['@/views/guide/account/index.vue'], resolve)
  },
  {
    path: '/guide/account/question',
    component: resolve => require(['@/views/guide/account/question.vue'], resolve)
  },
  {
    path: '/guide/account/success',
    component: resolve => require(['@/views/guide/account/success.vue'], resolve)
  },
  {
    path: '/index',
    component: resolve => require(['@/views/index.vue'], resolve),
    redirect: '/users/seeting',
    children: [
      //首页
      {
        path: '/dashboard/index',
        component: resolve => require(['@/views/dashboard/index.vue'], resolve)
      },
      {
        path: '/package/index',
        component: resolve => require(['@/views/package/index.vue'], resolve)
      },
      {
        path: '/package/details',
        component: resolve => require(['@/views/package/details.vue'], resolve)
      },
      {
        path: '/course/index',
        component: resolve => require(['@/views/course/index.vue'], resolve)
      },
      {
        path: '/course/all',
        component: resolve => require(['@/views/course/all.vue'], resolve)
      },
      {
        path: '/course/details',
        component: resolve => require(['@/views/course/details.vue'], resolve)
      },
      {
        path: '/course/player',
        component: resolve => require(['@/views/course/player.vue'], resolve)
      },
      {
        path: '/course/live',
        component: resolve => require(['@/views/course/live.vue'], resolve)
      },
      {
        path: '/course/download',
        component: resolve => require(['@/views/course/download.vue'], resolve)
      },
      {
        path: '/download/index',
        component: resolve => require(['@/views/download/index.vue'], resolve)
      },
      {
        path: '/download/gratis',
        component: resolve => require(['@/views/download/gratis.vue'], resolve)
      },
      {
        path: '/download/charge',
        component: resolve => require(['@/views/download/charge.vue'], resolve)
      },
      {
        path: '/config/site',
        component: resolve => require(['@/views/config/site.vue'], resolve)
      },
      {
        path: '/config/oss',
        component: resolve => require(['@/views/config/oss.vue'], resolve)
      },
      {
        path: '/config/sms',
        component: resolve => require(['@/views/config/sms.vue'], resolve)
      },
      {
        path: '/config/wechat',
        component: resolve => require(['@/views/config/wechat.vue'], resolve)
      },
      {
        path: '/config/password',
        component: resolve => require(['@/views/config/password.vue'], resolve)
      },
      {
        path: '/manage/index',
        component: resolve => require(['@/views/manage/index.vue'], resolve)
      },
      {
        path: '/manage/add_user',
        component: resolve => require(['@/views/manage/add_user.vue'], resolve)
      },
      {
        path: '/admin/index',
        component: resolve => require(['@/views/admin/index.vue'], resolve)
      },
      {
        path: '/admin/add',
        component: resolve => require(['@/views/admin/add.vue'], resolve)
      },
      {
        path: '/manage/setting',
        component: resolve => require(['@/views/manage/setting.vue'], resolve)
      },
      {
        path: '/manage/wechat',
        component: resolve => require(['@/views/manage/wechat.vue'], resolve)
      },
      {
        path: '/manage/adapay',
        component: resolve => require(['@/views/manage/adapay.vue'], resolve)
      },
      {
        path: '/chapter/index',
        component: resolve => require(['@/views/chapter/index.vue'], resolve)
      },
      {
        path: '/chapter/mock',
        component: resolve => require(['@/views/chapter/mock.vue'], resolve)
      },
      {
        path: '/users/index',
        component: resolve => require(['@/views/users/index.vue'], resolve)
      },
      {
        path: '/users/course',
        component: resolve => require(['@/views/users/course.vue'], resolve)
      },
      {
        path: '/users/package',
        component: resolve => require(['@/views/users/package.vue'], resolve)
      },
      {
        path: '/users/open',
        component: resolve => require(['@/views/users/open.vue'], resolve)
      },
      {
        path: '/users/douyin',
        component: resolve => require(['@/views/users/douyin.vue'], resolve)
      },
      {
        path: '/users/seeting',
        component: resolve => require(['@/views/users/seeting.vue'], resolve)
      },
      {
        path: '/order/index',
        component: resolve => require(['@/views/order/index.vue'], resolve)
      },
    ]
  },
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})
